import axios from 'axios'

const setAuthToken = (token) => {
  if (token) {
    // Apply Authorization header to every request
    axios.defaults.headers.common['Authorization'] = token
  } else {
    // Delete Authorization header from every request
    delete axios.defaults.headers.common['Authorization']
  }
}

export default setAuthToken